/**
 * Publik portal futeri: mas'ul tashkilot, aloqa, texnik yordam hamda
 * foydalanish shartlari va maxfiylik siyosatiga havolalar.
 */
import { Link } from "react-router-dom";

import { usePortalConfig, usePortalHome } from "@/shared/data/portal";
import { useI18n } from "@/shared/i18n";
import { FAQ_HREF, SECTION_PATHS } from "@/shared/lib/sectionRoutes";
import { StoreButton } from "@/pages/public/landing/MobileAppSection";
import { BrandMark, Icon } from "@/shared/ui/Icon";

export function PublicFooter() {
  const { t } = useI18n();
  const config = usePortalConfig();
  const settings = usePortalHome()?.settings;
  const appEnabled = settings?.mobile_app_enabled !== false;

  const links = [
    { to: SECTION_PATHS.appeal, label: t("nav.appealSend") },
    { to: SECTION_PATHS.tracking, label: t("nav.appealTrack") },
    { to: SECTION_PATHS.services, label: t("nav.services") },
    { to: SECTION_PATHS.market, label: t("nav.market") },
    { to: SECTION_PATHS.map, label: t("nav.map") },
    { to: FAQ_HREF, label: t("nav.faq") },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <Link className="brand" to="/">
              <BrandMark className="brand-mark" />
              <span className="brand-text">
                <b>{t("app.name")}</b>
                <span>{t("app.tagline")}</span>
              </span>
            </Link>
            <h4 className="footer-org-title">{t("footer.org")}</h4>
            <p className="footer-org">{t("footer.orgName")}</p>
          </div>

          <div>
            <h4>{t("footer.links")}</h4>
            <ul>
              {links.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>{t("footer.contacts")}</h4>
            <ul className="footer-contact-list">
              <li>
                <a href={`tel:${config.hotline}`}>
                  <Icon name="phone" size={16} />
                  <span>
                    <b>{config.hotline}</b>
                    <small>{t("hotline.hours")}</small>
                  </span>
                </a>
              </li>
              <li>
                <a href={`mailto:${config.email}`}>
                  <Icon name="mail" size={16} />
                  <span>{config.email}</span>
                </a>
              </li>
              <li>
                <span className="footer-line">
                  <Icon name="pin" size={16} />
                  <span>{config.address}</span>
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4>{t("footer.support")}</h4>
            <p>{t("footer.supportText")}</p>
            <a className="btn btn-ondark btn-sm footer-support-btn" href={`mailto:${config.email}`}>
              <Icon name="mail" size={14} />
              {config.email}
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            © {new Date().getFullYear()} {t("footer.orgName")}. {t("footer.rights")}
          </span>
          <nav className="footer-legal" aria-label={t("footer.privacy")}>
            <Link to={SECTION_PATHS.terms}>{t("footer.terms")}</Link>
            <Link to={SECTION_PATHS.privacy}>{t("footer.privacy")}</Link>
          </nav>
          {/* Fon surati litsenziyasi (CC BY-SA 4.0) muallifni ko'rsatishni talab qiladi */}
          <a
            className="footer-credit"
            href="https://commons.wikimedia.org/wiki/File:Zaamin_National_Park_in_July.jpg"
            target="_blank"
            rel="noopener noreferrer"
          >
            Foto: Zomin milliy bog'i — 26D, CC BY-SA 4.0
          </a>
        </div>

        {/* Eng pastda: mobil ilovani yuklab olish — ma'lumotlar bir qatorda. */}
        {appEnabled ? (
          <div className="footer-app">
            <span className="footer-app-icon" aria-hidden="true">
              <Icon name="smartphone" size={22} />
            </span>
            <div className="footer-app-copy">
              <b>{t("footer.appTitle")}</b>
              <span>{t("footer.appText")}</span>
            </div>
            <div className="footer-app-buttons">
              <StoreButton href={settings?.google_play_url ?? ""} store="google" label="Google Play" />
              <StoreButton href={settings?.app_store_url ?? ""} store="apple" label="App Store" />
            </div>
          </div>
        ) : null}
      </div>
    </footer>
  );
}
